export default __webpack_public_path__ + "images/VRG.9c0fd3b.png";